import React from 'react';
import { Calendar, TrendingUp, Users, Award } from 'lucide-react';
import './shared-analytics.css';

const TreatmentAnalytics = () => {
  return (
    <div className="treatment-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fff7ed', color: '#ea580c' }}>
            <Calendar size={24} />
          </div>
          <div className="card-content">
            <h3>Avg. Days in Treatment</h3>
            <div className="card-value">589</div>
            <div className="card-change neutral">All patients</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
            <TrendingUp size={24} />
          </div>
          <div className="card-content">
            <h3>Longest Treatment</h3>
            <div className="card-value">1023d</div>
            <div className="card-change positive">Patient ID: 42</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
            <Users size={24} />
          </div>
          <div className="card-content">
            <h3>New This Month</h3>
            <div className="card-value">3</div>
            <div className="card-change positive">+2 from last month</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#faf5ff', color: '#7c3aed' }}>
            <Award size={24} />
          </div>
          <div className="card-content">
            <h3>Success Rate</h3>
            <div className="card-value">87%</div>
            <div className="card-change positive">+3% from last quarter</div>
          </div>
        </div>
      </div>

      <div className="content-placeholder">
        <h3>Treatment Duration & Outcomes</h3>
        <p>Long-term treatment progress tracking and outcome analysis.</p>
        <ul>
          <li>Treatment duration trends</li>
          <li>Patient retention metrics</li>
          <li>Long-term adherence patterns</li>
          <li>Treatment milestone tracking</li>
          <li>Success rate analysis</li>
        </ul>
      </div>
    </div>
  );
};

export default TreatmentAnalytics;



